export default "__VITE_ASSET__CRCf4Nqd__"